.scroll-container {
    max-height: 750px;
    overflow-y: auto;
    margin-top: -8px;
}
